(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awaken-review-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('awaken-review-carousel')) {
  customElements.define('awaken-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.awaken-reviews__track');
      const cards = [...this.querySelectorAll('.awaken-reviews__card')];
      const buttons = [...this.querySelectorAll('[data-direction]')];
      const counter = this.querySelector('[data-counter]');
      const update = () => {
        const start = track.getBoundingClientRect().left + 4;
        let active = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const current = Math.abs(card.getBoundingClientRect().left - start);
          if (current < distance) { distance = current; active = index; }
        });
        counter.textContent = (active + 1) + ' / ' + cards.length;
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        track.scrollBy({left:Number(button.dataset.direction) * step, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-camp-popup"]) return;
  try {
    
(() => {
  const key = 'awaken-base-camp-popup-seen-v1';
  function remember() { try { sessionStorage.setItem(key, '1'); } catch (error) {} }
  function shown() { try { return sessionStorage.getItem(key) === '1'; } catch (error) { return false; } }
  function setup() {
    const dialog = document.getElementById('BaseCampWelcome');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    dialog.querySelectorAll('[data-bc-popup-close]').forEach(button => button.addEventListener('click', () => { remember(); dialog.close(); }));
    dialog.querySelector('[data-bc-popup-join]').addEventListener('click', remember);
    dialog.addEventListener('cancel', remember);
    dialog.addEventListener('close', remember);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    const open = () => {
      if (dialog.isConnected && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
    };
    if (dialog.dataset.editor === 'true') {
      document.addEventListener('shopify:section:select', event => { if (event.detail.sectionId === dialog.dataset.sectionId) open(); });
      return;
    }
    if (shown()) return;
    setTimeout(() => {
      if (document.querySelector('dialog[open]')) return;
      open();
      if (dialog.open) remember();
    }, Number(dialog.dataset.delay || 0) * 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["base-camp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const guideLink = event.target.closest('[data-bc-open]');
  if (guideLink) {
    const guide = document.getElementById(guideLink.dataset.bcOpen);
    if (guide && guide.tagName === 'DETAILS') guide.open = true;
  }
  const button = event.target.closest('[data-bc-download]');
  if (!button) return;
  const list = document.getElementById(button.dataset.bcDownload);
  if (!list) return;
  const title = list.querySelector('h3').textContent;
  const items = Array.from(list.querySelectorAll('li')).map(function(item) { return '[ ] ' + item.textContent; });
  const text = 'AWAKEN BASE CAMP\n' + title + '\n\n' + items.join('\n') + '\n\nAdapt this list to your destination and conditions.\n';
  const url = URL.createObjectURL(new Blob([text], {type:'text/plain;charset=utf-8'}));
  const link = document.createElement('a');
  link.href = url;
  link.download = button.dataset.bcFilename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(function() { URL.revokeObjectURL(url); }, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-apparel-form"] && !Shopify.designMode) return;
  try {
    
  function initializeAwakenQuote() {
    const service = document.getElementById('CustomForm-service');
    const fields = document.getElementById('CustomForm-event-fields');
    if (!service || !fields || service.dataset.initialized) return;
    service.dataset.initialized = 'true';
    const sync = () => {
      const isEvent = service.value === 'On-site event printing';
      fields.hidden = !isEvent;
      for (const input of fields.querySelectorAll('input')) input.disabled = !isEvent;
    };
    if (new URLSearchParams(window.location.search).get('service') === 'event') service.value = 'On-site event printing';
    service.addEventListener('change', sync);
    sync();
  }
  initializeAwakenQuote();
  document.addEventListener('DOMContentLoaded', initializeAwakenQuote);
  document.addEventListener('shopify:section:load', initializeAwakenQuote);

  function initializeAwakenItems() {
    const list = document.getElementById('CustomForm-items');
    const add = document.getElementById('CustomForm-add-item');
    const status = document.getElementById('CustomForm-item-status');
    if (!list || !add || list.dataset.initialized) return;
    list.dataset.initialized = 'true';
    const pristine = list.querySelector('.awaken-order-item').cloneNode(true);
    const syncRows = () => {
      const rows = Array.from(list.querySelectorAll('.awaken-order-item'));
      rows.forEach((row, index) => {
        const number = index + 1;
        row.querySelector('legend').textContent = 'Garment ' + number;
        row.querySelectorAll('[data-item-field]').forEach(input => {
          const field = input.dataset.itemField;
          const id = 'CustomForm-item-' + number + '-' + field;
          input.id = id;
          input.name = 'contact[Item ' + number + ' ' + (field === 'other' ? 'other details' : field) + ']';
          input.previousElementSibling?.setAttribute('for', id);
          const label = input.parentElement.querySelector('label');
          if (label) label.htmlFor = id;
        });
        const remove = row.querySelector('.awaken-remove-item');
        remove.hidden = rows.length === 1;
        remove.textContent = 'Remove garment ' + number;
        const other = row.querySelector('.awaken-item-other');
        const needsOther = row.querySelector('[data-item-field="color"]').value === 'Other color' || row.querySelector('[data-item-field="garment"]').value === 'Other / help me choose';
        other.hidden = !needsOther;
        other.querySelector('input').disabled = !needsOther;
      });
      add.disabled = rows.length >= 20;
    };
    add.addEventListener('click', () => {
      if (list.children.length >= 20) return;
      const row = pristine.cloneNode(true);
      list.appendChild(row);
      syncRows();
      row.querySelector('select').focus();
      status.textContent = 'Garment ' + list.children.length + ' added.';
    });
    list.addEventListener('change', syncRows);
    list.addEventListener('click', event => {
      const remove = event.target.closest('.awaken-remove-item');
      if (!remove || list.children.length <= 1) return;
      const row = remove.closest('.awaken-order-item');
      const next = row.nextElementSibling || row.previousElementSibling;
      row.remove();
      syncRows();
      next.querySelector('select').focus();
      status.textContent = 'Garment removed. ' + list.children.length + ' garment rows remain.';
    });
    syncRows();
  }
  initializeAwakenItems();
  document.addEventListener('DOMContentLoaded', initializeAwakenItems);
  document.addEventListener('shopify:section:load', initializeAwakenItems);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
